import { FC, ReactNode } from 'react'
import { Icon, Tooltip as UITooltip, Text, Link } from '@/ui'
import { TypographyStyles } from '@/styles'
import { insertBetween } from '@/utils/arrayHelpers'

interface Props {
  popup: {
    title?: string
    body: string | FC
    link?: string
    linkText?: string
  }
  labelComponent?: ReactNode
  className?: string
  bordered?: boolean
}

// Parse string bodies with <br/> into separated elements
const parseTooltipBody = (body: string): ReactNode => {
  if (body.includes('<br/>')) {
    return insertBetween<ReactNode>(
      body.split('<br/>'),
      <>
        <br />
        <br />
      </>
    )
  }

  return body
}

export const Tooltip = ({
  popup,
  labelComponent,
  bordered = false,
  className,
}: Props) => {
  return (
    <UITooltip>
      <UITooltip.Trigger asChild>
        <span className={`cursor-pointer ${className ?? ''}`}>
          {labelComponent}
        </span>
      </UITooltip.Trigger>

      <UITooltip.Content
        className={`w-min-[250px] ${bordered ? 'border-neutral-200' : 'border-none'}`}
      >
        {popup.title && (
          <Text variant={TypographyStyles.H3} className="pt-2 mb-4">
            {popup.title}
          </Text>
        )}

        {typeof popup.body === 'string' ? (
          <Text>{parseTooltipBody(popup.body)}</Text>
        ) : (
          <popup.body />
        )}

        {popup.link && (
          <div className="pt-1">
            <Link href={popup.link} newPage>
              <span className="inline-flex items-center gap-1">
                {popup.linkText || 'Learn more'}
                <Icon icon="arrow-right-long" />
              </span>
            </Link>
          </div>
        )}
      </UITooltip.Content>
    </UITooltip>
  )
}
